import { InfoAlert } from "./styles";
import closeIcon from "./imgs/close-icon.svg";
import headerImg from "./imgs/cloak_room_banner.webp";

const CloakroomModal = ({ serialNumber, onClose }) => {
  return (
    <InfoAlert>
      <div className="inner-container">
        <div className="img-container">
          <img src={headerImg} alt="header" />
          <h2>{"Cloakroom"}</h2>
        </div>
        <div className="close-button" onClick={onClose}>
          <img src={closeIcon} alt="close" />
        </div>
        <div className="scroll-view">
          <div className="section">
            <p>
              {
                "Scan your wristband to store and collect items at the cloakroom."
              }
            </p>
          </div>
        </div>
      </div>
    </InfoAlert>
  );
};

export default CloakroomModal;
